function convertMPHToMach(num) {
  let eq =
    "Converting " +
    num +
    " miles per hour to mach: \n" +
    num +
    " / 761.207 = ";
  let rep = num / 761.207;
  return eq + rep.toFixed(3);
}

function convertMPHToKnots(num) {
  let eq =
    "Converting " +
    num +
    " miles per hour to knots: \n" +
    num +
    " / 1.150779 = ";
  let rep = num / 1.150779;
  return eq + rep.toFixed(3);
}

function convertMPHToKPH(num) {
  let eq =
    "Converting " +
    num +
    " miles per hour to kilometers per hour:  \n" +
    num +
    " * 1.609344 = ";
  let rep = num * 1.609344;
  return eq + rep.toFixed(3);
}

export { convertMPHToMach, convertMPHToKnots, convertMPHToKPH };
